import { MapsAPILoader } from '@agm/core';
import { DatePipe } from '@angular/common';
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit {
  discussionForm:FormGroup
  @ViewChild("search")
  public searchElementRef: ElementRef;
  discussion_model={
    
      // email: '',
      // phone: 0,
      // location: '',
      // coordinates: [],
      // date: '',
      // job_for: '',
      // description: '',
      notes: '',
      admin_notes: '',
      question: '',
      sender_id: '',
      replied_id: '',
      content_id: '',
      status: '',
      course_id: '',
      answer: '',
      answer_type: ''
    
  }
  jobFor_list=[
    {name:'Fresher',id:'fresher'},
    {name:'Experienced',id:'experienced'}
  ]
  select_job=null
  discussion_id:any

  address: string;
  latitude: number;
  longitude: number;
  zoom: number;
  private geoCoder;
  currentUrl:any
  user_role:any
  constructor(private formBuilder: FormBuilder,public toastr: ToastrService, 
              private activerouter: ActivatedRoute,public apiService: ApiService,
              private route: Router) { 
                this.user_role = JSON.parse(localStorage.getItem('user'))
                this.currentUrl = this.activerouter.snapshot.routeConfig.path
                this.activerouter.paramMap.subscribe(params => {
                  this.discussion_id = params.get('id');
                })
              }

 
  ngOnInit(): void {

    this.discussionForm = this.formBuilder.group({
      question: ['',Validators.required],
      email: ['',Validators.required],
      phone: [''],
      date: [''],
      location: [''],
      description: [''],
      notes: [''],
      admin_notes: ['']
    })
    if(this.currentUrl === 'edit/:id'){
      this.getDiscussionById()
    }
  }
  get rf() {
    return this.discussionForm.controls;
  }
  getJobForId(event){
    console.log(this.select_job)
  }
  submit(){
    if(this.currentUrl ==='add'){
      let body={
        question: this.discussionForm.value.question,
        notes: this.discussionForm.value.notes,
        sender_id : this.user_role.id
      }
      
      this.apiService.createDiscussion(body).subscribe((res:any)=>{
        if(res.statusCode===200){
          this.toastr.success('created successfully!')
          if(this.user_role.roles ==='admin'){
            this.route.navigate(['discussions/list'])
          }
          if(this.user_role.roles ==='student'){
            this.route.navigate(['discussions/my-discussions'])
          }
        }
        else{
          this.toastr.error(res.error)
        }
      })
    }
    if(this.currentUrl ==='edit/:id'){
      this.apiService.updateDiscussion(this.discussion_id,this.discussion_model).subscribe((res:any)=>{
        if(res.statusCode===200){
          this.toastr.success('updated successfully!')
          this.route.navigate(['discussions/list'])
        }
        else{
          this.toastr.error(res.error)
        }
    })
    
  }
}
  back(){
    if(this.user_role.roles ==='admin'){
      this.route.navigate(['discussions/list'])
    }
    if(this.user_role.roles ==='student'){
      this.route.navigate(['discussions/my-discussions'])
    }

  }
  getDiscussionById(){
    this.apiService.getDiscussionById(this.discussion_id).subscribe((res:any)=>{
      if(res.statusCode === 200){
        console.log(res)
        this.discussion_model.question = res?.data[0]?.question
        // this.discussion_model.email = res?.data[0]?.email
        // this.discussion_model.phone = res?.data[0]?.phone
        // this.select_job = res?.data[0]?.job_for
        // this.discussion_model.job_for = this.select_job
        // this.discussion_model.description = res?.data[0]?.description
        // this.discussion_model.date = res?.data[0]?.date
        this.discussion_model.notes = res?.data[0]?.notes
        this.discussion_model.admin_notes = res?.data[0]?.admin_notes
        // this.discussion_model.location = res?.data[0]?.address?.location

      }
      else{
        this.toastr.error(res.error)
      }
    })
  }

}
